import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { api } from '../../api.ts';
import { InvoiceView, type Invoice } from '../../components/InvoiceView.tsx';

export function ReferrerInvoicePage() {
  const { id } = useParams();
  const [invoice, setInvoice] = useState<Invoice | null | 'missing'>(null);

  useEffect(() => {
    api.get<{ invoice: Invoice }>(`/referrer/invoices/${id}`).then((r) => setInvoice(r.invoice)).catch(() => setInvoice('missing'));
  }, [id]);

  return (
    <div style={{ maxWidth: 820, margin: '0 auto', padding: '24px 20px 48px' }}>
      <Link to="/apporteur" className="no-print" style={{ fontSize: 13, fontWeight: 700, color: 'var(--accent-dark)', textDecoration: 'none', display: 'inline-block', marginBottom: 14 }}>
        ← Retour à mon espace
      </Link>
      {invoice === null && <div className="empty-state">Chargement…</div>}
      {invoice === 'missing' && <div className="error-banner">Facture introuvable.</div>}
      {invoice && invoice !== 'missing' && <InvoiceView invoice={invoice} />}
    </div>
  );
}
